'use client';

import { ScrollArea } from '@/components/ui/scroll-area';
import { cn } from '../../../lib/utils';
import { type ReactNode } from 'react';

interface ScrollableContainerProps {
  children: ReactNode;
  className?: string;
}

export function ScrollableContainer({
  children,
  className
}: ScrollableContainerProps) {
  return (
    <ScrollArea className={cn(
      'h-full min-h-0',
      className
    )}>
      {children}
    </ScrollArea>
  );
} 